module.exports = __webpack_public_path__ + "img/Primary-chevron.14fd7ab8.svg";